import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { 
  Dashboard, 
  ProductsPage, 
  VariantsPage, 
  UsersPage, 
  NotFoundPage, 
  SaleReturnPage, 
  LocationPage, 
  PickListPage,
  VendorStatementPage,
  AmazonPage,
  FlipkartPage,
  MyntraPage,
  AjioPage,
  NykaaPage,
  ReturnEntryLogPage,
  UtilityPage,
  Login,
  AnalyticsDashboard
} from '../pages';
import RequireAuth from '../components/common/RequireAuth';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      
      {/* Protected routes */}
      <Route path="/dashboard" element={
        <RequireAuth>
          <Dashboard />
        </RequireAuth>
      } />
      <Route path="/products" element={
        <RequireAuth>
          <ProductsPage />
        </RequireAuth>
      } />
      <Route path="/variants" element={
        <RequireAuth>
          <VariantsPage />
        </RequireAuth>
      } />
      <Route path="/users" element={
        <RequireAuth>
          <UsersPage />
        </RequireAuth>
      } />
      <Route path="/sale-return" element={
        <RequireAuth>
          <SaleReturnPage />
        </RequireAuth>
      } />
      <Route path="/inventory/location" element={
        <RequireAuth>
          <LocationPage />
        </RequireAuth>
      } />
      <Route path="/inventory/pick-list" element={
        <RequireAuth>
          <PickListPage />
        </RequireAuth>
      } />
      <Route path="/inventory/vendor-statements" element={
        <RequireAuth>
          <VendorStatementPage />
        </RequireAuth>
      } />
      
      {/* Marketplace Routes */}
      <Route path="/marketplace/amazon" element={
        <RequireAuth>
          <AmazonPage />
        </RequireAuth>
      } />
      <Route path="/marketplace/flipkart" element={
        <RequireAuth>
          <FlipkartPage />
        </RequireAuth>
      } />
      <Route path="/marketplace/myntra" element={
        <RequireAuth>
          <MyntraPage />
        </RequireAuth>
      } />
      <Route path="/marketplace/ajio" element={
        <RequireAuth>
          <AjioPage />
        </RequireAuth>
      } />
      <Route path="/marketplace/nykaa" element={
        <RequireAuth>
          <NykaaPage />
        </RequireAuth>
      } />
      <Route path="/marketplace/return-entry-log" element={
        <RequireAuth>
          <ReturnEntryLogPage />
        </RequireAuth>
      } />
      
      {/* Utility Route */}
      <Route path="/utility" element={
        <RequireAuth>
          <UtilityPage />
        </RequireAuth>
      } />
      
      {/* Analytics Route */}
      <Route path="/analytics" element={
        <RequireAuth>
          <AnalyticsDashboard />
        </RequireAuth>
      } />
    
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
